// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.icon-button {
  background: transparent;
  border: none;
  padding: 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0.85;
  transition: opacity 0.15s ease;
}

.icon-button:hover,
.icon-button--open {
  opacity: 1;
}

.icon-button:disabled {
  cursor: not-allowed;
  opacity: 0.28;
}

.twyn-cta-button {
  background: linear-gradient(to right, #4ca7f3, #6366f1);
  transition: background 0.2s ease, transform 0.1s ease;
}

.twyn-cta-button--disabled-base {
  background: linear-gradient(to right, #4b5563, #374151);
}

.twyn-cta-button--loading {
  background: linear-gradient(90deg, #4ca7f3, #6366f1, #4ca7f3);
  background-size: 200% 100%;
  animation: twyn-gradient-sweep 1.2s linear infinite;
  cursor: wait !important;
}

@keyframes twyn-gradient-sweep {
  0% {
    background-position: 0% 50%;
  }
  100% {
    background-position: -200% 50%;
  }
}

.terms-gate,
.terms-gate *,
.terms-gate *::before,
.terms-gate *::after {
  box-sizing: border-box;
}

.terms-gate {
  position: relative;
  display: grid;
  min-height: 100vh;
  min-height: 100dvh;
  width: 100%;
  place-items: center;
  overflow: hidden;
  padding: clamp(16px, 3vw, 40px);
  background:
    radial-gradient(circle at 50% -10%, rgba(34, 212, 240, 0.1), transparent 36%),
    linear-gradient(145deg, #020617 0%, #050817 48%, #080b1b 100%);
  color: #e5e7eb;
  isolation: isolate;
}

.terms-gate::before {
  position: absolute;
  inset: 0;
  z-index: -2;
  background-image:
    linear-gradient(rgba(148, 163, 184, 0.025) 1px, transparent 1px),
    linear-gradient(90deg, rgba(148, 163, 184, 0.025) 1px, transparent 1px);
  background-size: 48px 48px;
  content: "";
  mask-image: linear-gradient(to bottom, black, transparent 82%);
}

.terms-gate__ambient {
  position: absolute;
  z-index: -1;
  width: min(42vw, 600px);
  aspect-ratio: 1;
  border-radius: 50%;
  filter: blur(100px);
  opacity: 0.13;
  pointer-events: none;
}

.terms-gate__ambient--cyan {
  top: -26%;
  right: -8%;
  background: #22d4f0;
}

.terms-gate__ambient--violet {
  bottom: -35%;
  left: -8%;
  background: #6366f1;
}

.terms-modal {
  display: grid;
  grid-template-rows: auto minmax(0, 1fr) auto;
  width: min(920px, 100%);
  max-height: min(880px, calc(100dvh - clamp(32px, 6vw, 80px)));
  overflow: hidden;
  border: 1px solid rgba(71, 85, 105, 0.72);
  border-radius: 18px;
  background: rgba(2, 6, 23, 0.96);
  box-shadow:
    0 34px 90px rgba(0, 0, 0, 0.62),
    0 0 0 1px rgba(34, 212, 240, 0.035) inset;
}

.terms-modal__header {
  padding: 22px 28px 20px;
  border-bottom: 1px solid #1f2937;
  background:
    linear-gradient(120deg, rgba(34, 212, 240, 0.055), transparent 40%),
    rgba(8, 13, 32, 0.92);
}

.terms-modal__brand {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 22px;
}

.terms-modal__logo {
  width: 30px;
  height: 30px;
  border-radius: 7px;
  object-fit: cover;
}

.terms-modal__brand-name {
  background: linear-gradient(90deg, #22d4f0, #60a5fa 52%, #818cf8);
  background-clip: text;
  color: transparent;
  font-size: 1.25rem;
  font-weight: 750;
  letter-spacing: -0.02em;
}

.terms-modal__heading-row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 24px;
}

.terms-modal__eyebrow {
  margin: 0 0 7px;
  color: #22d4f0;
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.16em;
  text-transform: uppercase;
}

.terms-modal h1 {
  margin: 0;
  color: #f8fafc;
  font-size: clamp(1.75rem, 3vw, 2.35rem);
  letter-spacing: -0.035em;
  line-height: 1.08;
}

.terms-modal__description {
  max-width: 580px;
  margin: 9px 0 0;
  color: #94a3b8;
  font-size: 0.92rem;
  line-height: 1.55;
}

.terms-modal__document {
  min-height: 0;
  overflow-y: auto;
  padding: 28px clamp(24px, 4vw, 46px) 34px;
  background: rgba(2, 6, 23, 0.7);
  color: #cbd5e1;
  font-size: 0.88rem;
  line-height: 1.72;
  scrollbar-color: #334155 #090e21;
  scrollbar-width: thin;
}

.terms-modal__document:focus-visible {
  outline: 2px solid #22d4f0;
  outline-offset: -3px;
}

.terms-modal__document::-webkit-scrollbar {
  width: 10px;
}

.terms-modal__document::-webkit-scrollbar-track {
  background: #090e21;
}

.terms-modal__document::-webkit-scrollbar-thumb {
  border: 2px solid #090e21;
  border-radius: 999px;
  background: #334155;
}

.terms-document__title {
  margin: 0 auto 28px;
  text-align: center;
}

.terms-document__title h2 {
  margin: 0;
  color: #e2e8f0;
  font-size: clamp(1rem, 2.1vw, 1.2rem);
  letter-spacing: 0.055em;
  line-height: 1.48;
  text-transform: uppercase;
}

.terms-document__intro {
  margin: 0 0 13px;
}

.terms-document__intro strong,
.terms-document__clause strong {
  color: #f1f5f9;
  font-weight: 700;
}

.terms-document__section {
  margin-top: 25px;
}

.terms-document__section h3 {
  display: grid;
  grid-template-columns: 28px 1fr;
  gap: 3px;
  margin: 0 0 13px;
  color: #f8fafc;
  font-size: 1rem;
  line-height: 1.45;
}

.terms-document__section h3 > span {
  color: #f8fafc;
}

.terms-document__clause {
  display: grid;
  grid-template-columns: 36px 1fr;
  gap: 8px;
  margin: 0 0 13px 28px;
}

.terms-document__clause-marker {
  color: #cbd5e1;
  font-weight: 700;
}

.terms-modal__footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  padding: 18px 28px;
  border-top: 1px solid #1f2937;
  background: rgba(8, 13, 32, 0.96);
}

.terms-agreement {
  display: inline-flex;
  align-items: flex-start;
  gap: 12px;
  color: #e2e8f0;
  cursor: pointer;
  font-size: 0.87rem;
  line-height: 1.4;
}

.terms-agreement--disabled {
  color: #94a3b8;
  cursor: not-allowed;
}

.terms-agreement input {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  opacity: 0;
}

.terms-agreement input:disabled + .terms-agreement__control {
  border-color: #334155;
  background: #0f172a;
  opacity: 0.6;
}

.terms-agreement__control {
  display: grid;
  flex: 0 0 auto;
  width: 21px;
  height: 21px;
  margin-top: 1px;
  place-items: center;
  border: 1px solid #475569;
  border-radius: 5px;
  background: #020617;
  color: transparent;
  font-size: 0.78rem;
  transition:
    border-color 0.16s ease,
    background 0.16s ease,
    box-shadow 0.16s ease;
}

.terms-agreement input:checked + .terms-agreement__control {
  border-color: #38bdf8;
  background: linear-gradient(145deg, #0ea5e9, #6366f1);
  color: white;
  box-shadow: 0 0 18px rgba(34, 212, 240, 0.2);
}

.terms-agreement input:focus-visible + .terms-agreement__control {
  outline: 2px solid #67e8f9;
  outline-offset: 3px;
}

.terms-agreement small {
  display: block;
  margin-top: 3px;
  color: #64748b;
  font-size: 0.72rem;
}

.terms-modal__accept {
  flex: 0 0 auto;
  min-width: 175px;
  padding: 11px 19px;
  border: 0;
  border-radius: 999px;
  background: linear-gradient(90deg, #38bdf8, #6366f1);
  box-shadow: 0 9px 24px rgba(79, 70, 229, 0.24);
  color: white;
  cursor: pointer;
  font-size: 0.88rem;
  font-weight: 700;
  transition:
    filter 0.16s ease,
    transform 0.16s ease,
    opacity 0.16s ease;
}

.terms-modal__accept:hover:not(:disabled) {
  filter: brightness(1.08);
  transform: translateY(-1px);
}

.terms-modal__accept:focus-visible {
  outline: 2px solid #67e8f9;
  outline-offset: 3px;
}

.terms-modal__accept:disabled {
  background: #334155;
  box-shadow: none;
  color: #94a3b8;
  cursor: not-allowed;
  opacity: 0.62;
}

@media (max-width: 680px) {
  .terms-gate {
    padding: 0;
  }

  .terms-modal {
    width: 100%;
    min-height: 100vh;
    min-height: 100dvh;
    max-height: 100dvh;
    border: 0;
    border-radius: 0;
  }

  .terms-modal__header {
    padding: 18px 20px 16px;
  }

  .terms-modal__brand {
    margin-bottom: 16px;
  }

  .terms-modal__document {
    padding: 24px 20px 30px;
    font-size: 0.84rem;
  }

  .terms-document__clause {
    grid-template-columns: 30px 1fr;
    gap: 5px;
    margin-left: 16px;
  }

  .terms-modal__footer {
    align-items: stretch;
    flex-direction: column;
    gap: 15px;
    padding: 16px 20px calc(16px + env(safe-area-inset-bottom));
  }

  .terms-modal__accept {
    width: 100%;
  }
}

@media (prefers-reduced-motion: reduce) {
  .terms-modal__accept,
  .terms-agreement__control {
    transition: none;
  }
}

/* Premium dark mode glassmorphism styles for Mapbox popups */
.mapboxgl-popup {
  z-index: 50;
  pointer-events: none;
}
.mapboxgl-popup-content {
  background: rgba(15, 23, 42, 0.96) !important;
  color: #f3f4f6 !important;
  border: 1px solid rgba(255, 255, 255, 0.15) !important;
  border-radius: 8px !important;
  box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.5) !important;
  padding: 10px 14px !important;
  font-family: Avenir, sans-serif !important;
}
.mapboxgl-popup-anchor-top .mapboxgl-popup-tip {
  border-bottom-color: rgba(15, 23, 42, 0.96) !important;
}
.mapboxgl-popup-anchor-bottom .mapboxgl-popup-tip {
  border-top-color: rgba(15, 23, 42, 0.96) !important;
}
.mapboxgl-popup-anchor-left .mapboxgl-popup-tip {
  border-right-color: rgba(15, 23, 42, 0.96) !important;
}
.mapboxgl-popup-anchor-right .mapboxgl-popup-tip {
  border-left-color: rgba(15, 23, 42, 0.96) !important;
}

`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,UAAU;EACV,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,8BAA8B;AAChC;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,uDAAuD;EACvD,qDAAqD;AACvD;;AAEA;EACE,uDAAuD;AACzD;;AAEA;EACE,6DAA6D;EAC7D,0BAA0B;EAC1B,mDAAmD;EACnD,uBAAuB;AACzB;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,8BAA8B;EAChC;AACF;;AAEA;;;;EAIE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,+BAA+B;EAC/B;;kEAEgE;EAChE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX;;2EAEyE;EACzE,0BAA0B;EAC1B,WAAW;EACX,8DAA8D;AAChE;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,4CAA4C;EAC5C,uBAAuB;EACvB,6DAA6D;EAC7D,gBAAgB;EAChB,yCAAyC;EACzC,mBAAmB;EACnB,gCAAgC;EAChC;;6CAE2C;AAC7C;;AAEA;EACE,uBAAuB;EACvB,gCAAgC;EAChC;;yBAEuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,iEAAiE;EACjE,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,cAAc;EACd,uCAAuC;EACvC,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,yCAAyC;EACzC,+BAA+B;EAC/B,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,gCAAgC;EAChC,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;EAC1B,oBAAoB;AACtB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,qCAAqC;EACrC,uBAAuB;EACvB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,QAAQ;EACR,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,QAAQ;EACR,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,6BAA6B;EAC7B,iCAAiC;AACnC;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;EACvB,SAAS;EACT,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,cAAc;EACd,WAAW;EACX,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB;;;yBAGuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,qDAAqD;EACrD,YAAY;EACZ,4CAA4C;AAC9C;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;EACT,oBAAoB;EACpB,oDAAoD;EACpD,8CAA8C;EAC9C,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB;;;sBAGoB;AACtB;;AAEA;EACE,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA;IACE,+BAA+B;IAC/B,QAAQ;IACR,iBAAiB;EACnB;;EAEA;IACE,oBAAoB;IACpB,sBAAsB;IACtB,SAAS;IACT,2DAA2D;EAC7D;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE;;IAEE,gBAAgB;EAClB;AACF;;AAEA,6DAA6D;AAC7D;EACE,WAAW;EACX,oBAAoB;AACtB;AACA;EACE,6CAA6C;EAC7C,yBAAyB;EACzB,sDAAsD;EACtD,6BAA6B;EAC7B,0DAA0D;EAC1D,6BAA6B;EAC7B,0CAA0C;AAC5C;AACA;EACE,sDAAsD;AACxD;AACA;EACE,mDAAmD;AACrD;AACA;EACE,qDAAqD;AACvD;AACA;EACE,oDAAoD;AACtD","sourcesContent":[".App {\n  text-align: center;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.icon-button {\n  background: transparent;\n  border: none;\n  padding: 0;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  opacity: 0.85;\n  transition: opacity 0.15s ease;\n}\n\n.icon-button:hover,\n.icon-button--open {\n  opacity: 1;\n}\n\n.icon-button:disabled {\n  cursor: not-allowed;\n  opacity: 0.28;\n}\n\n.twyn-cta-button {\n  background: linear-gradient(to right, #4ca7f3, #6366f1);\n  transition: background 0.2s ease, transform 0.1s ease;\n}\n\n.twyn-cta-button--disabled-base {\n  background: linear-gradient(to right, #4b5563, #374151);\n}\n\n.twyn-cta-button--loading {\n  background: linear-gradient(90deg, #4ca7f3, #6366f1, #4ca7f3);\n  background-size: 200% 100%;\n  animation: twyn-gradient-sweep 1.2s linear infinite;\n  cursor: wait !important;\n}\n\n@keyframes twyn-gradient-sweep {\n  0% {\n    background-position: 0% 50%;\n  }\n  100% {\n    background-position: -200% 50%;\n  }\n}\n\n.terms-gate,\n.terms-gate *,\n.terms-gate *::before,\n.terms-gate *::after {\n  box-sizing: border-box;\n}\n\n.terms-gate {\n  position: relative;\n  display: grid;\n  min-height: 100vh;\n  min-height: 100dvh;\n  width: 100%;\n  place-items: center;\n  overflow: hidden;\n  padding: clamp(16px, 3vw, 40px);\n  background:\n    radial-gradient(circle at 50% -10%, rgba(34, 212, 240, 0.1), transparent 36%),\n    linear-gradient(145deg, #020617 0%, #050817 48%, #080b1b 100%);\n  color: #e5e7eb;\n  isolation: isolate;\n}\n\n.terms-gate::before {\n  position: absolute;\n  inset: 0;\n  z-index: -2;\n  background-image:\n    linear-gradient(rgba(148, 163, 184, 0.025) 1px, transparent 1px),\n    linear-gradient(90deg, rgba(148, 163, 184, 0.025) 1px, transparent 1px);\n  background-size: 48px 48px;\n  content: \"\";\n  mask-image: linear-gradient(to bottom, black, transparent 82%);\n}\n\n.terms-gate__ambient {\n  position: absolute;\n  z-index: -1;\n  width: min(42vw, 600px);\n  aspect-ratio: 1;\n  border-radius: 50%;\n  filter: blur(100px);\n  opacity: 0.13;\n  pointer-events: none;\n}\n\n.terms-gate__ambient--cyan {\n  top: -26%;\n  right: -8%;\n  background: #22d4f0;\n}\n\n.terms-gate__ambient--violet {\n  bottom: -35%;\n  left: -8%;\n  background: #6366f1;\n}\n\n.terms-modal {\n  display: grid;\n  grid-template-rows: auto minmax(0, 1fr) auto;\n  width: min(920px, 100%);\n  max-height: min(880px, calc(100dvh - clamp(32px, 6vw, 80px)));\n  overflow: hidden;\n  border: 1px solid rgba(71, 85, 105, 0.72);\n  border-radius: 18px;\n  background: rgba(2, 6, 23, 0.96);\n  box-shadow:\n    0 34px 90px rgba(0, 0, 0, 0.62),\n    0 0 0 1px rgba(34, 212, 240, 0.035) inset;\n}\n\n.terms-modal__header {\n  padding: 22px 28px 20px;\n  border-bottom: 1px solid #1f2937;\n  background:\n    linear-gradient(120deg, rgba(34, 212, 240, 0.055), transparent 40%),\n    rgba(8, 13, 32, 0.92);\n}\n\n.terms-modal__brand {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 22px;\n}\n\n.terms-modal__logo {\n  width: 30px;\n  height: 30px;\n  border-radius: 7px;\n  object-fit: cover;\n}\n\n.terms-modal__brand-name {\n  background: linear-gradient(90deg, #22d4f0, #60a5fa 52%, #818cf8);\n  background-clip: text;\n  color: transparent;\n  font-size: 1.25rem;\n  font-weight: 750;\n  letter-spacing: -0.02em;\n}\n\n.terms-modal__heading-row {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 24px;\n}\n\n.terms-modal__eyebrow {\n  margin: 0 0 7px;\n  color: #22d4f0;\n  font-size: 0.7rem;\n  font-weight: 700;\n  letter-spacing: 0.16em;\n  text-transform: uppercase;\n}\n\n.terms-modal h1 {\n  margin: 0;\n  color: #f8fafc;\n  font-size: clamp(1.75rem, 3vw, 2.35rem);\n  letter-spacing: -0.035em;\n  line-height: 1.08;\n}\n\n.terms-modal__description {\n  max-width: 580px;\n  margin: 9px 0 0;\n  color: #94a3b8;\n  font-size: 0.92rem;\n  line-height: 1.55;\n}\n\n.terms-modal__document {\n  min-height: 0;\n  overflow-y: auto;\n  padding: 28px clamp(24px, 4vw, 46px) 34px;\n  background: rgba(2, 6, 23, 0.7);\n  color: #cbd5e1;\n  font-size: 0.88rem;\n  line-height: 1.72;\n  scrollbar-color: #334155 #090e21;\n  scrollbar-width: thin;\n}\n\n.terms-modal__document:focus-visible {\n  outline: 2px solid #22d4f0;\n  outline-offset: -3px;\n}\n\n.terms-modal__document::-webkit-scrollbar {\n  width: 10px;\n}\n\n.terms-modal__document::-webkit-scrollbar-track {\n  background: #090e21;\n}\n\n.terms-modal__document::-webkit-scrollbar-thumb {\n  border: 2px solid #090e21;\n  border-radius: 999px;\n  background: #334155;\n}\n\n.terms-document__title {\n  margin: 0 auto 28px;\n  text-align: center;\n}\n\n.terms-document__title h2 {\n  margin: 0;\n  color: #e2e8f0;\n  font-size: clamp(1rem, 2.1vw, 1.2rem);\n  letter-spacing: 0.055em;\n  line-height: 1.48;\n  text-transform: uppercase;\n}\n\n.terms-document__intro {\n  margin: 0 0 13px;\n}\n\n.terms-document__intro strong,\n.terms-document__clause strong {\n  color: #f1f5f9;\n  font-weight: 700;\n}\n\n.terms-document__section {\n  margin-top: 25px;\n}\n\n.terms-document__section h3 {\n  display: grid;\n  grid-template-columns: 28px 1fr;\n  gap: 3px;\n  margin: 0 0 13px;\n  color: #f8fafc;\n  font-size: 1rem;\n  line-height: 1.45;\n}\n\n.terms-document__section h3 > span {\n  color: #f8fafc;\n}\n\n.terms-document__clause {\n  display: grid;\n  grid-template-columns: 36px 1fr;\n  gap: 8px;\n  margin: 0 0 13px 28px;\n}\n\n.terms-document__clause-marker {\n  color: #cbd5e1;\n  font-weight: 700;\n}\n\n.terms-modal__footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 24px;\n  padding: 18px 28px;\n  border-top: 1px solid #1f2937;\n  background: rgba(8, 13, 32, 0.96);\n}\n\n.terms-agreement {\n  display: inline-flex;\n  align-items: flex-start;\n  gap: 12px;\n  color: #e2e8f0;\n  cursor: pointer;\n  font-size: 0.87rem;\n  line-height: 1.4;\n}\n\n.terms-agreement--disabled {\n  color: #94a3b8;\n  cursor: not-allowed;\n}\n\n.terms-agreement input {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  overflow: hidden;\n  opacity: 0;\n}\n\n.terms-agreement input:disabled + .terms-agreement__control {\n  border-color: #334155;\n  background: #0f172a;\n  opacity: 0.6;\n}\n\n.terms-agreement__control {\n  display: grid;\n  flex: 0 0 auto;\n  width: 21px;\n  height: 21px;\n  margin-top: 1px;\n  place-items: center;\n  border: 1px solid #475569;\n  border-radius: 5px;\n  background: #020617;\n  color: transparent;\n  font-size: 0.78rem;\n  transition:\n    border-color 0.16s ease,\n    background 0.16s ease,\n    box-shadow 0.16s ease;\n}\n\n.terms-agreement input:checked + .terms-agreement__control {\n  border-color: #38bdf8;\n  background: linear-gradient(145deg, #0ea5e9, #6366f1);\n  color: white;\n  box-shadow: 0 0 18px rgba(34, 212, 240, 0.2);\n}\n\n.terms-agreement input:focus-visible + .terms-agreement__control {\n  outline: 2px solid #67e8f9;\n  outline-offset: 3px;\n}\n\n.terms-agreement small {\n  display: block;\n  margin-top: 3px;\n  color: #64748b;\n  font-size: 0.72rem;\n}\n\n.terms-modal__accept {\n  flex: 0 0 auto;\n  min-width: 175px;\n  padding: 11px 19px;\n  border: 0;\n  border-radius: 999px;\n  background: linear-gradient(90deg, #38bdf8, #6366f1);\n  box-shadow: 0 9px 24px rgba(79, 70, 229, 0.24);\n  color: white;\n  cursor: pointer;\n  font-size: 0.88rem;\n  font-weight: 700;\n  transition:\n    filter 0.16s ease,\n    transform 0.16s ease,\n    opacity 0.16s ease;\n}\n\n.terms-modal__accept:hover:not(:disabled) {\n  filter: brightness(1.08);\n  transform: translateY(-1px);\n}\n\n.terms-modal__accept:focus-visible {\n  outline: 2px solid #67e8f9;\n  outline-offset: 3px;\n}\n\n.terms-modal__accept:disabled {\n  background: #334155;\n  box-shadow: none;\n  color: #94a3b8;\n  cursor: not-allowed;\n  opacity: 0.62;\n}\n\n@media (max-width: 680px) {\n  .terms-gate {\n    padding: 0;\n  }\n\n  .terms-modal {\n    width: 100%;\n    min-height: 100vh;\n    min-height: 100dvh;\n    max-height: 100dvh;\n    border: 0;\n    border-radius: 0;\n  }\n\n  .terms-modal__header {\n    padding: 18px 20px 16px;\n  }\n\n  .terms-modal__brand {\n    margin-bottom: 16px;\n  }\n\n  .terms-modal__document {\n    padding: 24px 20px 30px;\n    font-size: 0.84rem;\n  }\n\n  .terms-document__clause {\n    grid-template-columns: 30px 1fr;\n    gap: 5px;\n    margin-left: 16px;\n  }\n\n  .terms-modal__footer {\n    align-items: stretch;\n    flex-direction: column;\n    gap: 15px;\n    padding: 16px 20px calc(16px + env(safe-area-inset-bottom));\n  }\n\n  .terms-modal__accept {\n    width: 100%;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .terms-modal__accept,\n  .terms-agreement__control {\n    transition: none;\n  }\n}\n\n/* Premium dark mode glassmorphism styles for Mapbox popups */\n.mapboxgl-popup {\n  z-index: 50;\n  pointer-events: none;\n}\n.mapboxgl-popup-content {\n  background: rgba(15, 23, 42, 0.96) !important;\n  color: #f3f4f6 !important;\n  border: 1px solid rgba(255, 255, 255, 0.15) !important;\n  border-radius: 8px !important;\n  box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.5) !important;\n  padding: 10px 14px !important;\n  font-family: Avenir, sans-serif !important;\n}\n.mapboxgl-popup-anchor-top .mapboxgl-popup-tip {\n  border-bottom-color: rgba(15, 23, 42, 0.96) !important;\n}\n.mapboxgl-popup-anchor-bottom .mapboxgl-popup-tip {\n  border-top-color: rgba(15, 23, 42, 0.96) !important;\n}\n.mapboxgl-popup-anchor-left .mapboxgl-popup-tip {\n  border-right-color: rgba(15, 23, 42, 0.96) !important;\n}\n.mapboxgl-popup-anchor-right .mapboxgl-popup-tip {\n  border-left-color: rgba(15, 23, 42, 0.96) !important;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
